import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { Card, Elevation } from '@blueprintjs/core';
import { userLogin } from '../../redux/actions/user.actions';
import LoadingButton from '../widgets/LoadingButton';

class LoginForm extends Component {
    state = {
        email: '',
        password: ''
    }
    login = () => {
        const { email, password } = this.state;
        const { location: { state }, userLogin } = this.props;
        const { from } = state || { from: { pathname: '/dashboard' } }
        userLogin({ email, password, from });
    }
    onChangeText = ({ value, event }) => {
        this.setState({ [value]: event.target.value });
    }
    onKeyDown = event => {
        const evt = event || window.event;
        var key = evt.keyCode || evt.which;
        if (key === 13) {
            this.login();
        }
    }
    render() {
        const { user: { isLoading }} = this.props;
        return (
            <Card
                elevation={Elevation.THREE}
                className="login-card">
                <div className="login-header">Login</div>
                <div className="login-input">
                    <input autoFocus className="pt-input pt-fill"
                        onChange={event => this.onChangeText({ value: 'email', event })}
                        onKeyDown={this.onKeyDown}
                        placeholder="E-mail"
                        dir="auto" />
                </div>
                <div className="pt-input-group login-input">
                    <input type="password"
                        onChange={event => this.onChangeText({ value: 'password', event })}
                        onKeyDown={this.onKeyDown}
                        className="pt-input"
                        placeholder="Enter your password..." />
                    <button className="pt-button pt-minimal pt-intent-warning pt-icon-lock" />
                </div>
                <LoadingButton className="pt-button pt-fill pt-intent-primary pt-large" text="Login" onClick={() => this.login()} isLoading={isLoading} />
            </Card>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
});
  
const mapDispatchToProps = {
    userLogin
};

const LoginFormContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginForm);

export default withRouter(LoginFormContainer);


// WEBPACK FOOTER //
// ./src/components/authentication/LoginForm.jsx